"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactChartjs = require("react-chartjs-2");

var _moment = _interopRequireDefault(require("moment"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

require("./_credits-graph.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var monkey = _vars.COLOURS.cyan.jungleGreen.monkey;
var bigFat = _vars.COLOURS.grey.athens.bigFat;
var SHADOW_DATA_SET_OPTIONS = {
  label: 'video shadow',
  fill: false,
  lineTension: 0.5,
  backgroundColor: bigFat,
  borderColor: bigFat,
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointRadius: 0,
  pointBackgroundColor: 'transparent',
  pointBorderColor: 'transparent'
};

function renderGraph(monthlySubmissions) {
  if (!monthlySubmissions.length) {
    return null;
  }

  var monthsData = [].concat(_toConsumableArray(monthlySubmissions.map(function (_ref, index) {
    var date = _ref.date;
    return (index === monthlySubmissions.length - 1 ? 'THIS MONTH' : (0, _moment.default)(date).format('MMM \'YY')).toUpperCase();
  })), [(0, _moment.default)().add(1, 'M').format('MMM \'YY').toUpperCase()]);
  var submissionsData = monthlySubmissions.map(function (_ref2) {
    var submissions = _ref2.submissions;
    return submissions;
  });
  var shadowData = submissionsData.map(function (data) {
    return data - 2 < 2 ? 0 : data - 2;
  });
  var pointColor = monthsData.map(function (_, index) {
    return index !== monthsData.length - 2 ? _vars.COLOURS.cyan.aqua : monkey;
  });
  var pointRadius = monthsData.map(function (_, index) {
    return index !== monthsData.length - 2 ? 3 : 4;
  });
  var data = {
    labels: monthsData,
    datasets: [_objectSpread({}, SHADOW_DATA_SET_OPTIONS, {
      label: 'VIDEOS',
      backgroundColor: monkey,
      borderColor: monkey,
      pointBackgroundColor: pointColor,
      pointBorderColor: pointColor,
      pointRadius: pointRadius,
      pointHitRadius: 10,
      data: submissionsData
    }), _objectSpread({}, SHADOW_DATA_SET_OPTIONS, {
      data: shadowData
    })]
  };
  var options = {
    legend: {
      display: false
    },
    tooltips: {
      displayColors: false,
      footerAlign: 'center',
      xPadding: 15,
      yPadding: 15,
      callbacks: {
        title: function title() {
          /* istanbul ignore next */
          return null;
        },
        label: function label(tooltipItem) {
          // Don't render shadow dataset tooltip

          /* istanbul ignore next */
          if (tooltipItem.datasetIndex === 1) {
            return null;
          }
          /* istanbul ignore next */


          return "".concat(tooltipItem.value, " VIDEOS");
        }
      }
    },
    layout: {
      padding: {
        top: 25,
        bottom: 10,
        left: 60,
        right: 60
      }
    },
    scales: {
      pointLabels: {
        fontStyle: 'bold'
      },
      xAxes: [{
        position: 'top',
        gridLines: {
          drawBorder: false,
          display: true
        },
        ticks: {
          padding: 25
        }
      }],
      yAxes: [{
        display: false
      }]
    }
  };
  return _react.default.createElement(_reactChartjs.Line, {
    data: data,
    options: options,
    height: 240,
    width: 1400
  });
}

function Graph(_ref3) {
  var monthlySubmissions = _ref3.monthlySubmissions;
  return _react.default.createElement("div", {
    className: "credits-graph"
  }, _react.default.createElement("div", {
    className: "credits-graph__wrapper"
  }, _react.default.createElement("div", {
    className: "credits-graph__wrapper__container"
  }, renderGraph(monthlySubmissions))));
}

var _default = (0, _react.memo)(Graph);

exports.default = _default;